import { Stack, Typography, useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { organizationProfileApi } from 'src/api/organization-profile';
import ProfessionalAssistantChat from 'src/sections/@dashboard/profile/components/ProfessionalAssistantChat';
import { translateKey } from 'src/locales/translate';


export default function OrganizationPatientTabsAssistantPage() {
  const { patientId } = useParams<{ patientId: string }>();
  const theme = useTheme();

  const { data: profile } = useQuery(
    ['patient-details', patientId],
    () =>
      organizationProfileApi.organizationProfileControllerPreviewProfileInOrganization(
        {
          profileId: patientId ?? '',
        },
      ),
    {
      enabled: !!patientId,
    },
  );

  if (!profile?.data) {
    return null;
  }

  return (
    <Stack
      sx={{
        gap: 1,
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        boxShadow: theme.customShadows.z8,
      }}
    >
      <Stack
        sx={{
          borderTopRightRadius: theme.spacing(2),
          borderTopLeftRadius: theme.spacing(2),
          gap: 0.5,
          paddingX: 3,
          paddingY: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography variant="h6">{translateKey("visit.aiChatTitle")}</Typography>
        <Typography variant="body2" color="text.secondary">{translateKey("hardcoded.asystnet_vetsi_posiada_wszystkie_informacje_na_temat_historii")}</Typography>
      </Stack>
      <Stack
        sx={{
          paddingX: 3,
          paddingY: 2,
          paddingTop: 1,
          gap: 2,
        }}
      >
        <ProfessionalAssistantChat
          profileId={profile.data.id}
          profileName={profile.data.name}
        />
      </Stack>
    </Stack>
  );
}
